/*! Copyright (c) Safe As Milk. All rights reserved. */
import ModalDialog from "modal-dialog";

import { StateSwitch } from "utils";

class FiltersDialog extends ModalDialog {
    #boundHandleMediaQueryChange;
    #initiated;
    #stateSwitch=null;
    #mobileFilterStates=new Map();
    #mobileFilterMedia=null;
    #mobileFilterObserver=null;
    #boundRememberMobileFilter;
    #boundRestoreMobileFilters;
    constructor() {
        super();
        this.#boundHandleMediaQueryChange = this.#handleMediaQueryChange.bind(this);
        this.#boundRememberMobileFilter = this.#rememberMobileFilter.bind(this);
        this.#boundRestoreMobileFilters = this.#restoreMobileFilters.bind(this);
    }
    connectedCallback() {
        this.disableOnDesktop = this.hasAttribute("data-disable-modal-on-desktop");
        if (this.disableOnDesktop) {
            this.#stateSwitch = new StateSwitch({
                max: "desk"
            });
            this.#initiated = false;
            if (this.#stateSwitch.active()) this.init();
            this.#stateSwitch.on(this.#boundHandleMediaQueryChange);
        } else {
            this.init();
        }
        this.#mobileFilterMedia = window.matchMedia("(max-width: 980px)");
        this.addEventListener("click", this.#boundRememberMobileFilter, true);
        this.#mobileFilterMedia.addEventListener("change", this.#boundRestoreMobileFilters);
        this.#mobileFilterObserver = new MutationObserver(this.#boundRestoreMobileFilters);
        this.#mobileFilterObserver.observe(this, { childList: true, subtree: true, attributes: true, attributeFilter: ["open"] });
        this.#restoreMobileFilters();
    }
    disconnectedCallback() {
        this.removeEventListener("click", this.#boundRememberMobileFilter, true);
        this.#mobileFilterMedia?.removeEventListener("change", this.#boundRestoreMobileFilters);
        this.#mobileFilterObserver?.disconnect();
        if (this.#initiated) {
            this.destroy();
        }
        if (this.#stateSwitch) this.#stateSwitch.off(this.#boundHandleMediaQueryChange);
    }
    #rememberMobileFilter(event) {
        if (!this.#mobileFilterMedia?.matches) return;
        const summary = event.target.closest?.("summary");
        const details = summary?.parentElement;
        if (!details?.matches(".js-filters details") || details.hasAttribute("non-dismissible")) return;
        const key = this.#mobileFilterKey(details);
        if (key) this.#mobileFilterStates.set(key, details.classList.contains("is-closing") || !details.open);
    }
    #mobileFilterKey(details) {
        return details.querySelector("input[name]")?.name || details.id;
    }
    #restoreMobileFilters() {
        if (!this.#mobileFilterMedia?.matches) return;
        this.querySelectorAll(".js-filters details").forEach(details => {
            const key = this.#mobileFilterKey(details);
            if (!key) return;
            const open = this.#mobileFilterStates.get(key) === true;
            if (details.open === open || (!open && details.classList.contains("is-closing"))) return;
            details.style.removeProperty("height");
            details.style.removeProperty("overflow");
            details.open = open;
        });
    }
    init() {
        this.querySelector("aside").setAttribute("role", "document");
        this.setAttribute("aria-hidden", "true");
        this.classList.add("modal", "modal--filters");
        this.#initiated = true;
        super.init();
    }
    destroy() {
        this.querySelector("aside").removeAttribute("role");
        this.removeAttribute("aria-hidden");
        this.classList.remove("modal", "modal--filters");
        this.#initiated = false;
        super.destroy();
    }
    async #handleMediaQueryChange(e) {
        if (e.matches && !this.#initiated) {
            this.init();
        } else if (this.#initiated) {
            await this.close();
            this.destroy();
        }
    }
}

customElements.define("filters-dialog", FiltersDialog);
//# sourceMappingURL=filters-dialog.js.map

